import api from '@/api';

export default {
	state: {
		summary: null,
		categoriesSummary: null,
		progress: null
	},
	mutations: {
		SET_SCHOOL_SUMMARY (state, summary) {
			state.summary = summary;
		},
		SET_SCHOOL_CATEGORIES_SUMMARY (state, categoriesSummary) {
			state.categoriesSummary = categoriesSummary;
		},
		SET_SCHOOL_PROGRESS (state, progress) {
			state.progress = progress;
		},
		CLEAR_SCHOOL_SUMMARY (state) {
			state.categoriesSummary = null;
			state.summary = null;
		},
		CLEAR_SCHOOL_PROGRESS (state) {
			state.progress = null;
		}
	},
	actions: {

		async setSchoolSummary (context, summary) {
			context.commit('SET_SCHOOL_SUMMARY', summary);
		},

		async setSchoolCategoriesSummary (context, categoriesSummary) {
			context.commit('SET_SCHOOL_CATEGORIES_SUMMARY', categoriesSummary);
		},

		async setSchoolProgress (context, progress) {
			context.commit('SET_SCHOOL_PROGRESS', progress);
		},

		async clearSchoolSummary (context) {
			context.commit('CLEAR_SCHOOL_SUMMARY');
		},

		async clearSchoolProgress (context) {
			context.commit('CLEAR_SCHOOL_PROGRESS');
		}

	}
};



// WEBPACK FOOTER //
// ./src/store/school/index.js